export default __webpack_public_path__ + "img/970118a51348e332fda9094e41d0c12e.png";